import api from '../../api'

const state={   //要设置的全局访问的state对象
    areaList: null,
};
const getters = {   //实时监听state值的变化(最新状态)
    getAreaList() { 
        let set = res=>{
            state.areaList = res; 
            localStorage.setItem('areaList_artapp_web',JSON.stringify(res));
        }
        let find = (callback)=>{
            if(state.areaList){
                if( typeof(callback)==='function' ){
                    callback(state.areaList);
                }
            }
            else{
                let a = localStorage.getItem('areaList_artapp_web');
                if(a){
                    a = JSON.parse(a);
                    set(a);
                    if( typeof(callback)==='function' ){
                        callback(a);
                    }
                }else{
                    api.pub.getAllArea().then(res=>{
                        console.log(res,'vuex里面的geeer');
                        let b = res.body.allArea;
                        set(b);
                        if( typeof(callback)==='function'){
                            callback(b);
                        }
                    }).catch(res=>{
        
                    })
                }
            }
        }
        return find
    }
};
const mutations = {
};
const actions = {

};
export default {
   namespaced: true, //用于在全局引用此文里的方法时标识这一个的文件名
   state,
   getters,
   mutations,
   actions
}